import {
    Box,
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    InputAdornment,
    TextField,
} from '@mui/material';
import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import * as React from 'react';
import { useEffect, useState } from 'react';
import {
    ChangeStaffPasswordFields,
    ChangeStaffPasswordRequest,
} from 'types/add-staff-user/change-staff-password';
import { useLazyChangeStaffPasswordQuery } from 'store/slices/staff/change-staff-password';
import { ReactComponent as NounEye } from 'assets/images/sign-in/noun-eye.svg';
import { ReactComponent as Eye } from 'assets/images/sign-in/eye.svg';
import { useAppDispatch } from 'hooks/redux';
import rgba from 'assets/theme/function/rgba';
import DialogIconClose from 'component/dialog-icon-close';
import { openSnackbar } from 'store/slices/snackbar/snackbar-slice';

interface Props {
    closeModal: () => void;
    staffId: string;
}

export const initialMainChangeStaffPasswordFilterData: ChangeStaffPasswordRequest =
    {
        password: '',
    };

const ChangeStaffPassword: React.FC<Props> = (props: Props) => {
    const { closeModal, staffId } = props;
    const [changeStaffPasswordInfo, setChangeStaffPasswordInfo] =
        useState<ChangeStaffPasswordFields>(
            initialMainChangeStaffPasswordFilterData,
        );
    const [showPass, setShowPass] = useState<boolean>(false);
    const [showConfirmPass, setConfirmShowPass] = useState<boolean>(false);
    const dispatch = useAppDispatch();

    const [changeStaffPassword, { error, isError }] =
        useLazyChangeStaffPasswordQuery();

    const handleChangeStaffPasswordClick = () => {
        if (validateChangePasswordData()) {
            changeStaffPassword({ ...changeStaffPasswordInfo, id: staffId });
            closeModal();
        }
    };

    const validateChangePasswordData = (): boolean => {
        let isValid = true;
        let errorText = '';

        if (
            changeStaffPasswordInfo.password == '' ||
            changeStaffPasswordInfo.password == 'Invalid Date'
        ) {
            isValid = false;
            errorText = 'Password fields are empty';
        }
        if (
            changeStaffPasswordInfo.passwordConfirm == '' ||
            changeStaffPasswordInfo.passwordConfirm == 'Invalid Date'
        ) {
            isValid = false;
            errorText = 'Password Confirm fields are empty';
        }

        if (!isValid) {
            dispatch(
                openSnackbar({
                    message: errorText,
                    severity: 'error',
                    open: true,
                    position: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                }),
            );
        }

        return isValid;
    };

    useEffect(() => {
        if (error && 'data' in error) {
            dispatch(
                openSnackbar({
                    message: error?.data.message,
                    severity: 'error',
                    open: true,
                    position: {
                        vertical: 'top',
                        horizontal: 'right',
                    },
                }),
            );
        }
    }, [isError]);

    return (
        <>
            <Box
                display={'flex'}
                justifyContent={'center'}
                bgcolor={rgba(colors.primary.main, 0.1)}
            >
                <DialogTitle textTransform={'uppercase'}>
                    ChANGE PASSWORD
                </DialogTitle>
                <DialogIconClose handleClose={closeModal} />
            </Box>
            <DialogContent>
                <Box mt={pxToRem(5)} display={'flex'}>
                    <TextField
                        fullWidth
                        label={'Password'}
                        name={'password'}
                        type={showPass ? 'text' : 'password'}
                        slotProps={{
                            input: {
                                'aria-label': 'password',
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                setShowPass(
                                                    (current) => !current,
                                                )
                                            }
                                            onMouseDown={(e) =>
                                                e.preventDefault()
                                            }
                                            edge="end"
                                        >
                                            {showPass ? <Eye /> : <NounEye />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                        }}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setChangeStaffPasswordInfo((prevState) => ({
                                ...prevState,
                                [name]: value,
                            }));
                        }}
                    />

                    <TextField
                        sx={{ ml: pxToRem(5) }}
                        fullWidth
                        label={'Password Confirm'}
                        name={'passwordConfirm'}
                        onChange={(e) => {
                            const { name, value } = e.target;
                            setChangeStaffPasswordInfo((prevState) => ({
                                ...prevState,
                                [name]: value,
                            }));
                        }}
                        type={showConfirmPass ? 'text' : 'password'}
                        slotProps={{
                            input: {
                                'aria-label': 'password',
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={() =>
                                                setConfirmShowPass(
                                                    (current) => !current,
                                                )
                                            }
                                            onMouseDown={(e) =>
                                                e.preventDefault()
                                            }
                                            edge="end"
                                        >
                                            {showConfirmPass ? (
                                                <Eye />
                                            ) : (
                                                <NounEye />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    fullWidth
                    onClick={handleChangeStaffPasswordClick}
                    variant={'contained'}
                >
                    Change Password
                </Button>
            </DialogActions>
        </>
    );
};
export default ChangeStaffPassword;
